// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-fluid[data-v-62dc2165] {\n    max-width: 1200px;\n    margin-left: 0;\n}\n.col-form-label[data-v-62dc2165] {\n    width: 100px;\n    padding-right: 10px;\n}\ninput[data-v-62dc2165]:disabled{\n    z-index: -1;\n    border-left-width: 0px !important;\n}\n.default-input[data-v-62dc2165]{\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
